<template>
  <h3 class="text-xl mb-5 flex">
    <span
      class="border-4 w-5 h-5 block border-red-400 rounded-full mr-4 shrink-0 relative top-[2px]"
    />
    <span><slot /></span>
  </h3>
</template>
